import * as types from 'Actions/types'
import { createAction } from 'Utils/redux'

export const updateField = createAction(
  types.FORM_UPDATE_FIELD,
  'meta',
  'payload'
)
